module.exports = __webpack_public_path__ + "media/25-Shernelle_Charles_Testimonial.bbdae460.mp3";